export const settlementContext = {
  data: '/order-service/rest/api/external/settlement/data',
  report: '/order-service/rest/api/external/settlement/data/report',
};
